import React from 'react'
import { H2, Button, CheckboxInput, FlexCenter, Flex } from '../../lib/components'
import { NDA_ACCEPTANCE_CHECKBOX_LABELS } from '../../lib/utils/nda-acceptance'
import { AcceptNDAText } from './accept-nda-text'
import './accept-nda.scss'

interface SelfdeclarationProps {
  isButtonDisabled: boolean
  handleChange: (fieldName: string, value: boolean) => void
  handleButtonClick: () => void
  expand: boolean
  acceptedNDA: boolean
  acceptedTNC: boolean
  handleSelfDeclarationSubmit: () => void
  campaignOpportunityTitle?: string | null
}
const AcceptNDAPresenter = React.forwardRef<HTMLDivElement, SelfdeclarationProps>(
  (
    {
      isButtonDisabled,
      handleChange,
      handleButtonClick,
      expand,
      acceptedNDA,
      acceptedTNC,
      handleSelfDeclarationSubmit,
      campaignOpportunityTitle,
    },
    ref,
  ) => {
    return (
      <>
        <div className='self-declaration-container'>
          <div className='self-declaration-heading'>
            <H2 text={'Confidentiality Agreement'} />
          </div>
          <div className='self-declaration-sub-heading'>
            {campaignOpportunityTitle ? (
              <p data-testid='nda-campaign-context'>
                Accept the confidentiality agreement to continue to{' '}
                <strong>{campaignOpportunityTitle}</strong>.
              </p>
            ) : (
              <p>
                Read the Confidentiality agreement and confirm the acceptance of our terms of
                service.
              </p>
            )}
          </div>
          <div
            className={`self-declaration-wrapper ${
              expand ? 'self-declaration-wrapper-overflow' : ''
            }`}
            ref={ref}
            data-testid='nda-text-wrapper'
          >
            {/* <P text={text}/> */}
            <div className='self-declaration-wrapper-text'>
              <AcceptNDAText />
            </div>

            {!expand && (
              <div className='self-declaration-muted-wrapper'>
                <FlexCenter>
                  <Button
                    variant='secondary-btn'
                    classes={['self-declaration-expand-button']}
                    text='+'
                    handleClick={handleButtonClick}
                    testId='nda-expand-button'
                  />
                </FlexCenter>
              </div>
            )}
          </div>
          <div className='self-declaration-footer'>
            <Flex classes={['mb-16']}>
              <CheckboxInput
                labelText={NDA_ACCEPTANCE_CHECKBOX_LABELS.confidentiality}
                name='acceptedTNC'
                value={acceptedTNC ? 'true' : 'false'}
                handleChange={(val) => handleChange('acceptedTNC', val.target.checked)}
                dataTestId='nda-tnc-checkbox'
              />
            </Flex>
            <Flex classes={['mb-40']}>
              <CheckboxInput
                labelText={NDA_ACCEPTANCE_CHECKBOX_LABELS.noOffer}
                name='acceptedNDA'
                value={acceptedNDA ? 'true' : 'false'}
                handleChange={(val) => handleChange('acceptedNDA', val.target.checked)}
                dataTestId='nda-nda-checkbox'
              />
            </Flex>

            <Flex>
              <Button
                variant='primary-btn'
                classes={['auto-btn-width']}
                text='Accept'
                isDisabled={isButtonDisabled}
                handleClick={handleSelfDeclarationSubmit}
              />
            </Flex>
          </div>
        </div>
      </>
    )
  },
)

AcceptNDAPresenter.displayName = 'AcceptNDAPresenter'
export { AcceptNDAPresenter }
